
const sizeChangeEvents = ['resize', 'orientationchange']
const marqueeEl = document.querySelector('.js-marquee');
let marqueeHome;

class Marquee {
  parentEl;
  speed = 0.3
  isActive = false;
  autoplay;

  constructor(el, speed) {
    this.parentEl = el;
    this.speed = speed;
    this.isActive = true;
    this.children = this.parentEl.querySelectorAll('li');
    this.firstElement = this.children[0].cloneNode(true);
    this.firstElement.classList.add('clone');
    this.firstElement.ariaHidden = "true";
    this.initialWidth = 0;

    if (this.children.length > 1) {
      this.children.forEach((child) => {
        const clonedElement = child.cloneNode(true);
        this.initialWidth += child.clientWidth;

        clonedElement.classList.add('clone');
        clonedElement.ariaHidden = "true";

        this.parentEl.append(clonedElement);
      })

      // Clone the first element again to have a perfect loop when it restarts.
      this.parentEl.append(this.firstElement);
      this.initialWidth = this.initialWidth + this.children.length * 32;
    }

    let i = 0;
    this.autoplay = setInterval(() => {
      this.parentEl.style.transform = `translateX(-${i}px)`;
      if (i > this.initialWidth) {
        i = 0;
      }
      i = i + this.speed;
    }, 0);
  }

  destroy() {
    clearInterval(this.autoplay);
    const clonedEls = this.parentEl.querySelectorAll('.clone');
    clonedEls.forEach((clone) => {
      clone.remove()
    })
    this.parentEl.removeAttribute('style');
    this.isActive = false;
  }
}

if (marqueeEl) {
  MQCheck();

  sizeChangeEvents.forEach((event) => {
    window.addEventListener(event, debounce(MQCheck))
  })
}

function MQCheck() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    if(!marqueeHome?.isActive) {
      marqueeHome = new Marquee(marqueeEl,0.2);
    }
  } else {
    if (marqueeHome?.isActive) {
      marqueeHome.destroy();
    }
  }
}

// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
